export enum HexColor {
  PRIMARY = '#CE6E19',
  WHITE = '#FFFFFF',
  LIGHT_GREY = '#EDEDED',
  GREY = '#CCCCCB',
  DARK_GREY = '#7E7F83',
  LIGHT_ORANGE = '#FAA43A',
  ORANGE = '#F47A20',
  DARK_ORANGE = '#C06435',
  BLUE = '#2F4B5D',
  BLACK_GREY = '#2E2E2D',
}

interface RGB {
  r: number
  g: number
  b: number
}
export const hexColorToRGB = (color: HexColor): RGB => {
  if (color === HexColor.WHITE) return { r: 225, g: 225, b: 225 }
  else if (color === HexColor.LIGHT_GREY) return { r: 237, g: 237, b: 237 }
  else if (color === HexColor.GREY) return { r: 204, g: 204, b: 203 }
  else if (color === HexColor.DARK_GREY) return { r: 126, g: 127, b: 131 }
  else if (color === HexColor.LIGHT_ORANGE) return { r: 250, g: 164, b: 58 }
  else if (color === HexColor.ORANGE) return { r: 244, g: 122, b: 32 }
  else if (color === HexColor.DARK_ORANGE) return { r: 192, g: 100, b: 53 }
  else if (color === HexColor.BLUE) return { r: 47, g: 75, b: 93 }
  else if (color === HexColor.BLACK_GREY) return { r: 46, g: 46, b: 45 }
  else return { r: 206, g: 110, b: 25 }
}

interface CMYK {
  c: number
  m: number
  y: number
  k: number
}
export const hexColorToCMYK = (color: HexColor): CMYK => {
  if (color === HexColor.WHITE) return { c: 0, m: 0, y: 0, k: 0 }
  else if (color === HexColor.LIGHT_GREY) return { c: 6, m: 4, y: 4, k: 0 }
  else if (color === HexColor.GREY) return { c: 20, m: 15, y: 16, k: 0 }
  else if (color === HexColor.DARK_GREY) return { c: 53, m: 44, y: 41, k: 7 }
  else if (color === HexColor.LIGHT_ORANGE) return { c: 0, m: 41, y: 87, k: 0 }
  else if (color === HexColor.ORANGE) return { c: 0, m: 64, y: 100, k: 0 }
  else if (color === HexColor.DARK_ORANGE) return { c: 20, m: 70, y: 91, k: 6 }
  else if (color === HexColor.BLUE) return { c: 85, m: 63, y: 45, k: 30 }
  else if (color === HexColor.BLACK_GREY) return { c: 70, m: 64, y: 63, k: 63 }
  else return { c: 0, m: 60, y: 100, k: 18 }
}

interface GradientElement {
  hexColor: HexColor
  rgb: RGB
  cmyk: CMYK
}
interface Gradient {
  left: GradientElement
  right: GradientElement
}
export const PRIMARY_GRADIENT: Gradient = {
  left: {
    hexColor: HexColor.PRIMARY,
    rgb: hexColorToRGB(HexColor.PRIMARY),
    cmyk: hexColorToCMYK(HexColor.PRIMARY),
  },
  right: {
    hexColor: HexColor.ORANGE,
    rgb: hexColorToRGB(HexColor.ORANGE),
    cmyk: hexColorToCMYK(HexColor.ORANGE),
  },
}

const primaryGradientElement: GradientElement = {
  hexColor: HexColor.DARK_ORANGE,
  rgb: hexColorToRGB(HexColor.DARK_ORANGE),
  cmyk: hexColorToCMYK(HexColor.DARK_ORANGE),
}
export const SECONDARY_GRADIENT_LIGHT: Gradient = {
  left: primaryGradientElement,
  right: {
    hexColor: HexColor.WHITE,
    rgb: hexColorToRGB(HexColor.WHITE),
    cmyk: hexColorToCMYK(HexColor.WHITE),
  },
}

export const SECONDARY_GRADIENT_DARK: Gradient = {
  left: primaryGradientElement,
  right: {
    hexColor: HexColor.BLUE,
    rgb: hexColorToRGB(HexColor.BLUE),
    cmyk: hexColorToCMYK(HexColor.BLUE),
  },
}
